import { render, staticRenderFns } from "./_ImprovisedAttackDialog.vue?vue&type=template&id=b5e33096&"
import script from "./_ImprovisedAttackDialog.vue?vue&type=script&lang=ts&"
export * from "./_ImprovisedAttackDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports